const translations = {
  en: {
    // Sidebar / Panel
    profile: "PROFILE",
    contactUs: "CONTACT US",
    plan: "PLAN",
    history: "HISTORY",
    policies: "POLICIES",
    logOut: "LOG OUT",

    // Tab bar
    aiChat: "AI CHAT",
    translate: "TRANSLATE",
    transcribe: "TRANSCRIBE",

    // Page action buttons
    undo: "UNDO",
    redo: "REDO",
    changeView: "CHANGE VIEW",
    focusMode: "FOCUS MODE",

    // Translate page
    translateTo: "TRANSLATE TO:",
    language: "LANGUAGE",
    searchLanguage: "Search language...",
    noLanguageFound: "No language found",
    translateBtn: "TRANSLATE",
    uploadFile: "UPLOAD FILE",
    uploadFileTooltip: "Upload File",
    paste: "PASTE",
    pasteTooltip: "Paste",
    originalText: "ORIGINAL TEXT",
    translatedText: "TRANSLATED TEXT",
    originalPlaceholder: "Enter text to translate...",
    uploadingDocument: "Uploading document...",
    wordCount: "WORDS",
    personalIdentifiersProtected: "PROTECTED IDENTIFIERS",
    copy: "COPY",
    copied: "COPIED!",
    exportBtn: "EXPORT",
    translateWarning: "Remember to export your work.",
    translateWarning2: "Content is processed in real time and not stored.",
    translatePrivacyNotice: "Your information is not stored or used for AI training.",
    translateExportReminder: "Remember to export — your information is not stored or used for AI training.",
    protectingContent: "Protecting your content…",
    checkingPersonalInfo: "Checking for personal information.",
    personalIdentifiersProtectedLabel: "Personal identifiers protected",

    // Transcribe page
    audioLanguage: "AUDIO LANGUAGE",
    record: "RECORD",
    stop: "STOP",
    uploadAudioFile: "UPLOAD AUDIO FILE",
    uploadAudio: "UPLOAD",
    originalTranscription: "TRANSLATION",
    timestamp: "TIMESTAMP (00:01, 00:02...)",
    transcribeWarning: "Audio is processed for transcription only and not retained.",
    saveSuccess: "Saved successfully",

    // New session buttons
    newChat: "NEW CHAT",
    newTranslate: "NEW TRANSLATION",
    newTranscribe: "NEW TRANSCRIPTION",
    newSessionTitle: "Start New Session?",
    newChatSessionTitle: "START NEW CHAT?",
    newTranslateSessionTitle: "START NEW TRANSLATION?",
    newTranscribeSessionTitle: "START NEW TRANSCRIPTION?",
    newChatConfirm: "Your current chat will be permanently deleted. Make sure you have exported your work before continuing.",
    newTranslateConfirm: "Your current translation will be permanently deleted. Make sure you have exported your work before continuing.",
    newTranscribeConfirm: "Your current transcription will be permanently deleted. Make sure you have exported your work before continuing.",
    newSessionCancel: "CANCEL",
    newSessionConfirm: "CONFIRM",
    logoutConfirmTitle: "LOG OUT",
    logoutConfirmMsg: "Are you sure you want to log out?",

    // Chat page
    greeting: "What would you like to work on ?",
    greetingSubtitle: "Start a conversation with Linko.You can ask for help , get ideas , or work on your content.",
    chatLabel: "CHAT",
    inputLabel: "Type your message here...",
    uploadFileImage: "UPLOAD FILE / IMAGE",
    chatPrivacyNotice: "This conversation is not stored or used for AI training.",
    chatExportReminder: "Remember to export — this conversation is not stored or used for AI training.",
    uploadFileHeading: "Upload File",
    translateAndDownload: "TRANSLATE & DOWNLOAD",

    // Add to your translation object
    plansBullets: [
      "Unlimited chats with AI",
      "Priority response time",
      "Advanced analytics",
      "Team collaboration tools"
    ],
    subscribe: "Subscribe Now",
    contactUs: "Contact Us",
    professionals: "Professional",
    profPrice: "$29/mo",
    monthAbbr: "mo",
    orgs: "Organizations",
    orgPrice: "Custom",
    orgsPlanActiveMsg: "ORGs plan active",
    plansSubtitle: "Choose the plan that",
    plansSubtitleBold: "fits your needs",
    loginFirstMsg: "Please log in first to subscribe.",
    cancelSuccess: "Subscription cancelled successfully",

    // Footer
    footerMsg1: "AI can make mistakes, remember to check important information",
    footerMsg2: "Your information is confidential. Our AI is contained in a private, encrypted server",
    footerMsg3: "All your information is automatically deleted when you close this window",

    // AI Menu panel
    aiRules: "AI FRAMEWORKS",
    aiRulesSubtitle: "Your organization’s standards for working with AI",
    presets: "WORK MODES",
    workModesDesc: "Choose how this work should be produced.",
    noWorkModeTitle: "No Work Mode",
    noWorkModeDesc: "Use the AI Framework as configured.",
    noWorkModeAssignedTitle: "No Work Mode assigned yet",
    noWorkModeAssignedDesc: "A Work Mode will appear here when it is available.",
    promptLabel: "YOUR PROMPT",
    promptPlaceholder: "What do you need to improve in this text?",
    glossary: "GLOSSARY",
    applyFocusedEdits: "Apply focused edits to improve, adapt, or refine your text.",
    originalTextRadio: "Original Text",
    translatedTextRadio: "Translated Text",

    // Document upload
    docUploadHeading: "Perfect! What file do you want to translate?",
    selectTargetLanguage: "SELECT TARGET LANGUAGE",
    searchLangPlaceholder: "Search language...",
    noLanguageFoundDoc: "No language found",
    selectFile: "SELECT FILE",
    translateDoc: "TRANSLATE",
    fieldRequired: "This field is required",
    fileFormatError: "Please select .ppt, .pptx, .doc, .docx, .txt, .pdf",
    downloadError: "Error downloading file. Please try again.",
    downloadUrlError: "Download URL not found in response.",
    somethingWentWrong: "Something went wrong",

    // Login
    title1: "Professional AI for",
    title2: "multilingual work",
    plansSubtitle: "Built for professionals and organizations that need",
    plansSubtitleBold: "consistency, accuracy, and control.",
    plansSubtitleBold1: "consistency, accuracy,",
    plansSubtitleBold2: "and control.",
    plansBullets: [
      "Translation, transcription and AI chat.",
      "Secure processing of professional content",
      "Review and edit every AI result.",
      "Built for language professionals"
    ],
    professionalBullets: [
      "Secure AI for language work.",
      "Data anonymization.",
      "Review and edit AI results.",
      "Built for language professionals.",
    ],
    orgsBullets: [
      "Data anonymization.",
      "AI adapted to your organization's needs.",
      "Shared rules and presets across teams.",
      "Built for multilingual teams.",
    ],
    subtitle: "Translate, transcribe, and work with AI in a secure environment designed for professionals and organizations.",
    subtitle1: "Translate, transcribe, and work with AI",
    subtitle2: "in a secure environment",
    subtitle3: "designed for professionals and organizations.",
    card1Title: "Private",
    card1Sub: "by design",
    card2Title: "Data",
    card2Sub: "anonymization",
    card3Title: "No model",
    card3Sub: "training",
    trialBtn: "START FREE 7-DAY TRIAL",
    customPricing: "Custom pricing",
    plans: "PLANS",
    loginTab: "LOG IN",
    loginTitle: "Log in",
    emailPh: "Email",
    emailReq: "Email is required",
    emailInvalid: "Please enter a valid email address",
    passwordPh: "Password",
    passwordReq: "Password is required",
    forgotPwd: "Forgot Password?",
    forgotPwdDesc: "Enter your email and we'll send you a link to reset your password.",
    sendResetLink: "Send reset link",
    resetLinkSent: "Check your email",
    resetLinkSentDesc: "We've sent a password reset link to",
    resetLinkSentNote: "Didn't receive it? Check your spam folder or",
    resendLink: "resend",
    backToLogin: "← Back to log in",
    loginBtn: "Log in",
    or: "OR",
    googleLogin: "Log in with Google",
    googleSignUp: "Sign up with Google",
    newHere: "New here? Start free trial →",
    professionals: "Professionals",
    orgs: "Organizations",
    profPrice: "9",
    orgPrice: "99",
    subscribe: "Subscribe",
    contactUs: "Contact Us",
    contactUsTitle: "Contact Us",
    contactUsDesc: "Tell us about your organization and we'll get back to you.",
    contactUsNamePh: "Your Name",
    contactUsEmailPh: "Your Email",
    contactUsNotePh: "Tell us about your team or custom needs…",
    contactUsNameReq: "Name is required",
    contactUsEmailReq: "Email is required",
    contactUsEmailInvalid: "Enter a valid email",
    contactUsNoteReq: "Note is required",
    contactUsSend: "Send Request",
    contactUsSuccessTitle: "Request Sent!",
    contactUsSuccessDesc: "We've received your request and will be in touch soon.",
    loginFirstMsg: "Please log in first to subscribe.",
    backToApp: "Back to App",
    loginSuccess: "Successfully logged in!",
    cancelSuccess: "Subscription cancelled successfully.",
    requestSent: "Request Sent",
    googleLoginError: "Google login failed",
    invalidCredentials: "Invalid email or password",
    userNotFound: "User not found",
    incorrectPassword: "Incorrect password",
    emailAlreadyRegistered: "This email is already registered",
    paymentSuccessTitle: "Payment Successful!",
    paymentSuccessDesc: "Your plan has been activated. Welcome aboard!",
    paymentFailTitle: "Payment Failed",
    paymentFailDesc: "Something went wrong with your payment. Please try again.",
    paymentClose: "Close",
    paymentTryAgain: "Try Again",

    // Sign Up
    heading: "Create account",
    confirmPasswordPh: "Confirm Password",
    passwordMin: "Password must be at least 8 characters.",
    passwordStrong: "Password must contain uppercase, lowercase, number, and special character.",
    confirmReq: "Confirm password is required",
    confirmMatch: "Passwords must match",
    submitBtn: "SIGN UP",
    alreadyHave: "Already have an account? Log in →",
    leftTitle1: "Your private translation",
    leftTitle2: "assistant.",
    leftSubtitle: "Translate, transcribe, and work with AI in a secure environment designed for professionals and organizations.",
    signUpSuccess: "Successfully registered!",

    // Edit Profile
    editProfile: "EDIT PROFILE",
    emailLabel: "EMAIL",
    fullNameLabel: "FULL NAME",
    fullNamePlaceholder: "Full name",
    cancelBtn: "CANCEL",
    saveBtn: "SAVE",
    uploadImageTooltip: "Upload Image",
    profileUpdated: "Profile updated successfully!",
    profileUpdateFailed: "Failed to update profile",

    // Re-enable Payment
    reEnablePaymentTitle: "Re-enable Payment?",
    reEnablePaymentDesc: "Your subscription was cancelled. Would you like to re-enable automatic payments? You will be billed on the next renewal date.",
    reEnablePaymentCancel: "Cancel",
    reEnablePaymentConfirm: "Yes, Re-enable",
    reEnablePaymentButton: "Re-enable Payment",
    reEnablePaymentSuccess: "Payment re-enabled successfully. You will be billed on the next renewal date.",
    reEnablePaymentFailed: "Failed to re-enable payment. Please try again.",

    // Token Balance
    tokenBalance: "Token Balance",
    available: "Available",
    used: "Used",
    total: "Total",
    tokenLimitWarning: "Your token limit is almost reached. Please upgrade your plan.",
    purchaseTokens: "Purchase Tokens",
    perTokenPack: "$4.99 per token pack",
    tokenPlanNotAvailable: "Token plan not available",
    failedToPurchaseTokens: "Failed to purchase tokens",

    // Cancel / Switch Plan
    cancelPlan: "Cancel Plan",
    cancellingAtEnd: "Cancelling at end of billing period",
    planWillBeCancelled: "Plan will be cancelled at the end of the billing period.",
    switchPlanTitle: "Switch Plan?",
    switchPlanDesc: "Your current plan will be cancelled at the end of the billing period, then the new plan checkout will open.",
    confirmSwitch: "Confirm Switch",
    cancelPlanTitle: "Cancel Plan?",
    cancelPlanDesc: "Are you sure you want to cancel your subscription? You will lose access at the end of your billing period.",
    keepPlan: "Keep Plan",
    yesCancel: "Yes, Cancel",
    cancellingLabel: "Cancelling",
    activeLabel: "Active",
    failedToCancel: "Failed to cancel subscription",
    failedToSwitchPlan: "Failed to switch plan",
    sessionExpired: "Your session has expired. Please login again.",

    // Contact Us extra
    phoneRequired: "Phone number is required",
    phoneDigits: "Phone number must be between 7 and 15 digits",
    phoneInvalid: "Enter a valid phone number",
    countryCodeRequired: "Country code is required",
    phonePlaceholder: "Phone Number",
    contactReqSent: "Request Sent!",
    contactReqSentDesc: "We'll contact you as soon as possible.",
    contactClose: "Close",
    trialDaysLeft: "You have {n} day(s) left in your free trial",

    // Shared / Common
    downloadAs: "Download as",
    sendToTranslation: "Send to translation",
    or: "or",
    text: "Text",
    pdf: "PDF",
    word: "Word",
    upgradePlan: "Please upgrade your plan.",
    upgradePlanBtn: "Upgrade Plan",
    aiRulesOrgsOnly: "Advanced AI preferences are available only on the Organization plan.",
    tokenLimitWarning90: "You have almost reached your token limit. Please upgrade your plan.",
    tokenLimitWarning90Msg: "You have almost reached your token limit.",
    tokenLimitReached: "You have reached your token limit. Please upgrade your plan.",
    tokenLimitReachedMsg: "You have reached your token limit.",
    translation: "Translation",
    original: "Original",
    userLabel: "User",
    aiLabel: "AI",
    cancelBtn: "CANCEL",
    saveBtn: "SAVE",
    selectLangAndTranslate: "Select a language and click Translate",
    focusPanelPrompt: "Which panel do you want to focus on?",

    // Transcribe
    selectAudioLangFirst: "Please select an audio language before recording.",
    micNotAvailable: "Microphone access is not available. Please make sure the site is opened over HTTPS.",
    micError: "Microphone error:",
    audioProcessingFailed: "Audio processing failed. Please try again.",
    selectAudioLangUpload: "Please select an audio language before uploading",
    audioTranscriptionFailed: "Audio transcription failed. Please try again.",
    personLabel: "Person",
    noAudioUploaded: "No audio uploaded yet",
    noAudioUploadedSubtitle: "Upload an audio file or record your voice to see the transcription here.",
    noSpeechDetected: "No speech detected in the audio. Please try again with a clearer recording.",
    retranslating: "Retranslating...",
    processingAudio: "Processing audio...",
    transcribingPleaseWait: "Please wait while we transcribe your audio.",
    recordingInProgress: "Recording in progress...",
    saving: "Saving...",
    notConnectedToServer: "Not connected to server. Please wait and try again.",
    socketConnectionFailed: "Socket connection failed",
    serverErrorPrefix: "Server error",
    failedToProcessAudio: "Failed to process audio",
    requestedDeviceNotFound: "Requested device not found",

    // Translate
    pasteFallbackError: "Please use Ctrl+V (Cmd+V on Mac) to paste directly into the text area.",
    documentTranslationFailed: "Document translation failed",
    fileReadySelectLang: "File ready — please select a target language and click Translate",
    selectTargetLangFirst: "Please select a target language",
    translationFailed: "Translation failed",
    selectTargetLangBeforeUpload: "Please select a target language before uploading",
    translating: "Translating...",
    translatingDocument: "Translating document...",

    // Chat
    defaultUsername: "Usuario",
    botName: "LINKO",

    // MenuAI
    presetRequired: "Preset is required",
    noPresets: "No presets",
    promptRequired: "Prompt is required",
    generateAndDownload: "Generate Executive summary",
    generatedExecutiveSummarySuccess: "Generated Executive summary successfully",
    noChatHistoryFound: "No chat history found. Please start a conversation first.",
    noTranslateDataFound: "No text found to translate. Please enter text first.",
    noTranscribeDataFound: "No transcription found. Please transcribe audio first.",
    aiResult: "AI Result",
    apply: "Apply",

    // Sidebar extra
    defaultOrgName: "ORG / COMPANY",
    tokenWarning90ClickToUpgrade: "You have reached 90% of your token limit. Click here to upgrade your plan",
  },

  es: {
    // Sidebar / Panel
    profile: "PERFIL",
    contactUs: "CONTÁCTANOS",
    plan: "PLAN",
    history: "HISTORIAL",
    policies: "POLÍTICAS",
    logOut: "CERRAR SESIÓN",

    // Tab bar
    aiChat: "CHAT IA",
    translate: "TRADUCIR",
    transcribe: "TRANSCRIBIR",

    // Page action buttons
    undo: "DESHACER",
    redo: "REHACER",
    changeView: "CAMBIAR VISTA",
    focusMode: "MODO ENFOQUE",

    // Translate page
    translateTo: "TRADUCIR A:",
    language: "IDIOMA",
    searchLanguage: "Buscar idioma...",
    noLanguageFound: "No se encontró ningún idioma",
    translateBtn: "TRADUCIR",
    uploadFile: "SUBIR",
    uploadFileTooltip: "Subir Archivo",
    paste: "PEGAR",
    pasteTooltip: "Pegar",
    originalText: "TEXTO ORIGINAL",
    translatedText: "TEXTO TRADUCIDO",
    originalPlaceholder: "Ingrese texto para traducir...",
    uploadingDocument: "Subiendo documento...",
    wordCount: "PALABRAS",
    personalIdentifiersProtected: "IDENTIFICADORES PROTEGIDOS",
    copy: "COPIAR",
    copied: "¡COPIADO!",
    exportBtn: "EXPORTAR",
    translateWarning: "Recuerda exportar tu trabajo.",
    translateWarning2: "El contenido se procesa en tiempo real y no se almacena.",
    translatePrivacyNotice: "Tu información no se almacena ni se usa para entrenamiento de IA.",
    translateExportReminder: "Recuerda exportar — tu información no se almacena ni se usa para entrenamiento de IA.",
    protectingContent: "Protegiendo tu contenido…",
    checkingPersonalInfo: "Comprobando información personal.",
    personalIdentifiersProtectedLabel: "Identificadores personales protegidos",

    // Transcribe page
    audioLanguage: "IDIOMA DE AUDIO",
    record: "GRABAR",
    stop: "DETENER",
    uploadAudioFile: "SUBIR ARCHIVO DE AUDIO",
    uploadAudio: "SUBIR",
    originalTranscription: "TRADUCCIÓN",
    timestamp: "MARCA DE TIEMPO (00:01, 00:02...)",
    transcribeWarning: "El audio se procesa solo para transcripción y no se retiene.",
    saveSuccess: "Guardado correctamente",

    // New session buttons
    newChat: "NUEVO CHAT",
    newTranslate: "NUEVA TRADUCCIÓN",
    newTranscribe: "NUEVA TRANSCRIPCIÓN",
    newSessionTitle: "¿Iniciar nueva sesión?",
    newChatSessionTitle: "¿INICIAR NUEVO CHAT?",
    newTranslateSessionTitle: "¿INICIAR NUEVA TRADUCCIÓN?",
    newTranscribeSessionTitle: "¿INICIAR NUEVA TRANSCRIPCIÓN?",
    newChatConfirm: "Tu chat actual se eliminará permanentemente. Asegúrate de haber exportado tu trabajo antes de continuar.",
    newTranslateConfirm: "Tu traducción actual se eliminará permanentemente. Asegúrate de haber exportado tu trabajo antes de continuar.",
    newTranscribeConfirm: "Tu transcripción actual se eliminará permanentemente. Asegúrate de haber exportado tu trabajo antes de continuar.",
    newSessionCancel: "CANCELAR",
    newSessionConfirm: "CONFIRMAR",
    logoutConfirmTitle: "CERRAR SESIÓN",
    logoutConfirmMsg: "¿Estás seguro de que deseas cerrar sesión?",

    // Chat page
    greeting: "¿En qué te gustaría trabajar?",
    greetingSubtitle: "Inicia una conversación con Linko. Puedes pedir ayuda, obtener ideas o trabajar en tu contenido.",
    chatLabel: "CHARLAR",
    inputLabel: "Escribe tu mensaje aquí...",
    uploadFileImage: "SUBIR ARCHIVO / IMAGEN",
    chatPrivacyNotice: "Esta conversación no se almacena ni se usa para entrenamiento de IA.",
    chatExportReminder: "Recuerda exportar — esta conversación no se almacena ni se usa para entrenamiento de IA.",
    uploadFileHeading: "Subir Archivo",
    translateAndDownload: "TRADUCIR Y DESCARGAR",

    // Footer
    footerMsg1: "La IA puede cometer errores, recuerda revisar información importante",
    footerMsg2: "Tu información es confidencial. Nuestra IA está contenida en un servidor privado y encriptado",
    footerMsg3: "Toda tu información es borrada automáticamente al cerrar esta ventana",

    // AI Menu panel
    aiRules: "FRAMEWORKS DE IA",
    aiRulesSubtitle: "Estándares de tu organización para trabajar con IA",
    presets: "MODOS DE TRABAJO",
    workModesDesc: "Elige cómo debe producirse este trabajo.",
    noWorkModeTitle: "Sin modo de trabajo",
    noWorkModeDesc: "Usa el Framework de IA según lo configurado.",
    noWorkModeAssignedTitle: "Aún no se ha asignado ningún modo de trabajo",
    noWorkModeAssignedDesc: "Un modo de trabajo aparecerá aquí cuando esté disponible.",
    promptLabel: "TU INDICACIÓN",
    promptPlaceholder: "¿Qué necesitas mejorar en este texto?",
    glossary: "GLOSARIO",
    applyFocusedEdits: "Aplica ediciones enfocadas para mejorar, adaptar o refinar tu texto.",
    originalTextRadio: "Texto Original",
    translatedTextRadio: "Texto Traducido",

    // Document upload
    docUploadHeading: "¡Perfecto! ¿Qué archivo deseas traducir?",
    selectTargetLanguage: "SELECCIONA EL IDIOMA DE DESTINO",
    searchLangPlaceholder: "Buscar idioma...",
    noLanguageFoundDoc: "No se encontró ningún idioma",
    selectFile: "SELECCIONA EL ARCHIVO",
    translateDoc: "TRADUCIR",
    fieldRequired: "Este campo es obligatorio",
    fileFormatError: "Selecciona .ppt, .pptx, .doc, .docx, .txt, .pdf",
    downloadError: "Error al descargar el archivo. Por favor inténtalo de nuevo.",
    downloadUrlError: "No se encontró la URL de descarga en la respuesta.",
    somethingWentWrong: "Algo salió mal",

    // Login
    title1: "IA profesional para el",
    title2: "trabajo multilingüe",
    plansSubtitle: "Creado para profesionales y organizaciones que necesitan",
    plansSubtitleBold: "consistencia, precisión y control.",
    plansSubtitleBold1: "consistencia, precisión",
    plansSubtitleBold2: "y control.",
    plansBullets: [
      "Traducción, transcripción y chat con IA",
      "Procesamiento seguro de contenido profesional",
      "Revisa y edita cada resultado de IA.",
      "Diseñado para profesionales de idiomas."
    ],
    professionalBullets: [
      "IA segura para tu trabajo.",
      "Anonimización de datos.",
      "Revisa y edita los resultados de IA.",
      "Pensado para profesionales de idiomas.",
    ],
    orgsBullets: [
      "Anonimización de datos.",
      "IA adaptada a las necesidades de tu organización.",
      "Reglas y presets compartidos entre equipos.",
      "Pensado para equipos multilingües.",
    ],
    subtitle: "Traduce, transcribe y trabaja con IA de forma segura, en un entorno diseñado para profesionales y organizaciones.",
    subtitle1: "Traduce, transcribe y trabaja con IA",
    subtitle2: "de forma segura, en un entorno",
    subtitle3: "diseñado para profesionales y organizaciones.",
    card1Title: "Diseñado",
    card1Sub: "para privacidad",
    card2Title: "Anonimización",
    card2Sub: "de datos",
    card3Title: "Sin",
    card3Sub: "entrenamiento con tus datos",
    trialBtn: "COMIENZA TU PRUEBA GRATIS DE 7 DÍAS",
    customPricing: "Precio personalizado",
    plans: "PLANES",
    loginTab: "INICIAR SESIÓN",
    loginTitle: "Iniciar sesión",
    emailPh: "Correo electrónico",
    emailReq: "El correo electrónico es obligatorio",
    emailInvalid: "Por favor ingresa una dirección de correo válida",
    passwordPh: "Contraseña",
    passwordReq: "La contraseña es obligatoria",
    forgotPwd: "¿Olvidaste tu contraseña?",
    forgotPwdDesc: "Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.",
    sendResetLink: "Enviar enlace",
    resetLinkSent: "Revisa tu correo",
    resetLinkSentDesc: "Hemos enviado un enlace de restablecimiento a",
    resetLinkSentNote: "¿No lo recibiste? Revisa tu spam o",
    resendLink: "reenviar",
    backToLogin: "← Volver al inicio de sesión",
    loginBtn: "Iniciar sesión",
    or: "O",
    googleLogin: "Iniciar sesión con Google",
    googleSignUp: "Registrarse con Google",
    newHere: "¿Eres nuevo aquí? Inicia tu prueba gratuita →",
    professionals: "Profesionales",
    orgs: "Organizaciones",
    profPrice: "9",
    monthAbbr: "mes",
    orgPrice: "99",
    orgsPlanActiveMsg: "Plan de Organizaciones activo",
    subscribe: "Suscribirse",
    contactUs: "Contácteanos",
    contactUsTitle: "Contáctanos",
    contactUsDesc: "Cuéntanos sobre tu organización y nos pondremos en contacto contigo.",
    contactUsNamePh: "Tu Nombre",
    contactUsEmailPh: "Tu Correo",
    contactUsNotePh: "Cuéntanos sobre tu equipo o necesidades personalizadas…",
    contactUsNameReq: "El nombre es obligatorio",
    contactUsEmailReq: "El correo es obligatorio",
    contactUsEmailInvalid: "Ingresa un correo válido",
    contactUsNoteReq: "La nota es obligatoria",
    contactUsSend: "Enviar solicitud",
    contactUsSuccessTitle: "¡Solicitud enviada!",
    contactUsSuccessDesc: "Hemos recibido tu solicitud y nos pondremos en contacto pronto.",
    loginFirstMsg: "Por favor inicia sesión primero para suscribirte.",
    backToApp: "Volver a la App",
    loginSuccess: "¡Sesión iniciada exitosamente!",
    cancelSuccess: "Suscripción cancelada exitosamente.",
    requestSent: "Solicitud enviada",
    googleLoginError: "Error al iniciar sesión con Google",
    invalidCredentials: "Correo electrónico o contraseña incorrectos",
    userNotFound: "Usuario no encontrado",
    incorrectPassword: "Contraseña incorrecta",
    emailAlreadyRegistered: "Este correo electrónico ya está registrado",
    paymentSuccessTitle: "¡Pago exitoso!",
    paymentSuccessDesc: "Tu plan ha sido activado. ¡Bienvenido!",
    paymentFailTitle: "Pago fallido",
    paymentFailDesc: "Algo salió mal con tu pago. Por favor intenta de nuevo.",
    paymentClose: "Cerrar",
    paymentTryAgain: "Intentar de nuevo",

    // Sign Up
    heading: "Crear cuenta",
    confirmPasswordPh: "Confirmar Contraseña",
    passwordMin: "La contraseña debe tener al menos 8 caracteres.",
    passwordStrong: "La contraseña debe tener mayúsculas, minúsculas, número y carácter especial.",
    confirmReq: "Se requiere confirmar contraseña",
    confirmMatch: "Las contraseñas deben coincidir",
    submitBtn: "REGISTRARSE",
    alreadyHave: "¿Ya tienes cuenta? Inicia sesión →",
    leftTitle1: "Tu asistente privado",
    leftTitle2: "de traducción.",
    leftSubtitle: "Traduce, transcribe y trabaja con IA de forma segura, en un entorno diseñado para profesionales y organizaciones.",
    signUpSuccess: "¡Cuenta creada exitosamente!",

    // Edit Profile
    editProfile: "EDITAR PERFIL",
    emailLabel: "CORREO ELECTRÓNICO",
    fullNameLabel: "NOMBRE COMPLETO",
    fullNamePlaceholder: "Nombre completo",
    cancelBtn: "CANCELAR",
    saveBtn: "GUARDAR",
    uploadImageTooltip: "Subir Imagen",
    profileUpdated: "¡Perfil actualizado exitosamente!",
    profileUpdateFailed: "Error al actualizar el perfil",

    // Re-enable Payment
    reEnablePaymentTitle: "¿Reactivar pago?",
    reEnablePaymentDesc: "Tu suscripción fue cancelada. ¿Deseas reactivar los pagos automáticos? Se te cobrará en la próxima fecha de renovación.",
    reEnablePaymentCancel: "Cancelar",
    reEnablePaymentConfirm: "Sí, Reactivar",
    reEnablePaymentButton: "Reactivar Pago",
    reEnablePaymentSuccess: "Pago reactivado exitosamente. Se te cobrará en la próxima fecha de renovación.",
    reEnablePaymentFailed: "Error al reactivar el pago. Por favor intenta de nuevo.",

    // Token Balance
    tokenBalance: "Saldo de Tokens",
    available: "Disponible",
    used: "Usado",
    total: "Total",
    tokenLimitWarning: "Tu límite de tokens casi se ha alcanzado. Por favor actualiza tu plan.",
    purchaseTokens: "Comprar Tokens",
    perTokenPack: "$4.99 por paquete de tokens",
    tokenPlanNotAvailable: "Plan de tokens no disponible",
    failedToPurchaseTokens: "Error al comprar tokens",

    // Cancel / Switch Plan
    cancelPlan: "Cancelar Plan",
    cancellingAtEnd: "Cancelando al final del periodo de facturación",
    planWillBeCancelled: "El plan será cancelado al final del periodo de facturación.",
    switchPlanTitle: "¿Cambiar plan?",
    switchPlanDesc: "Tu plan actual será cancelado al final del periodo de facturación, luego se abrirá la compra del nuevo plan.",
    confirmSwitch: "Confirmar Cambio",
    cancelPlanTitle: "¿Cancelar plan?",
    cancelPlanDesc: "¿Estás seguro de que deseas cancelar tu suscripción? Perderás el acceso al final del periodo de facturación.",
    keepPlan: "Mantener Plan",
    yesCancel: "Sí, Cancelar",
    cancellingLabel: "Cancelando",
    activeLabel: "Activo",
    failedToCancel: "Error al cancelar la suscripción",
    failedToSwitchPlan: "Error al cambiar de plan",
    sessionExpired: "Tu sesión ha expirado. Por favor inicia sesión de nuevo.",

    // Contact Us extra
    phoneRequired: "El número de teléfono es obligatorio",
    phoneDigits: "El número de teléfono debe tener entre 7 y 15 dígitos",
    phoneInvalid: "Ingresa un número de teléfono válido",
    countryCodeRequired: "El código de país es obligatorio",
    phonePlaceholder: "Número de Teléfono",
    contactReqSent: "¡Solicitud enviada!",
    contactReqSentDesc: "Nos pondremos en contacto contigo pronto.",
    contactClose: "Cerrar",
    trialDaysLeft: "Te quedan {n} día(s) en tu prueba gratuita",

    // Shared / Common
    downloadAs: "Descargar como",
    sendToTranslation: "Enviar a traducción",
    or: "o",
    text: "Texto",
    pdf: "PDF",
    word: "Word",
    upgradePlan: "Por favor actualiza tu plan.",
    upgradePlanBtn: "Actualizar Plan",
    aiRulesOrgsOnly: "Las preferencias avanzadas de IA están disponibles solo en el plan de Organizaciones.",
    tokenLimitWarning90: "Casi has alcanzado tu límite de tokens. Por favor actualiza tu plan.",
    tokenLimitWarning90Msg: "Casi has alcanzado tu límite de tokens.",
    tokenLimitReached: "Has alcanzado tu límite de tokens. Por favor actualiza tu plan.",
    tokenLimitReachedMsg: "Has alcanzado tu límite de tokens.",
    translation: "Traducción",
    original: "Original",
    userLabel: "Usuario",
    aiLabel: "IA",
    cancelBtn: "CANCELAR",
    saveBtn: "GUARDAR",
    selectLangAndTranslate: "Selecciona un idioma y haz clic en Traducir",
    focusPanelPrompt: "¿En qué panel quieres enfocarte?",

    // Transcribe
    selectAudioLangFirst: "Por favor selecciona un idioma de audio antes de grabar.",
    micNotAvailable: "El acceso al micrófono no está disponible. Por favor asegúrate de que el sitio esté abierto por HTTPS.",
    micError: "Error de micrófono:",
    audioProcessingFailed: "Error al procesar el audio. Por favor intenta de nuevo.",
    selectAudioLangUpload: "Por favor selecciona un idioma de audio antes de subir",
    audioTranscriptionFailed: "Error en la transcripción de audio. Por favor intenta de nuevo.",
    personLabel: "Persona",
    noAudioUploaded: "No se ha subido audio aún",
    noAudioUploadedSubtitle: "Sube un archivo de audio o graba tu voz para ver la transcripción aquí.",
    noSpeechDetected: "No se detectó voz en el audio. Por favor intenta de nuevo con una grabación más clara.",
    retranslating: "Retraduciendo...",
    processingAudio: "Procesando audio...",
    transcribingPleaseWait: "Por favor espera mientras transcribimos tu audio.",
    recordingInProgress: "Grabación en progreso...",
    saving: "Guardando...",
    notConnectedToServer: "No conectado al servidor. Por favor espera e intenta de nuevo.",
    socketConnectionFailed: "Error de conexión del socket",
    serverErrorPrefix: "Error del servidor",
    failedToProcessAudio: "Error al procesar el audio",
    requestedDeviceNotFound: "Dispositivo solicitado no encontrado",

    // Translate
    pasteFallbackError: "Por favor usa Ctrl+V (Cmd+V en Mac) para pegar directamente en el área de texto.",
    documentTranslationFailed: "Error en la traducción del documento",
    fileReadySelectLang: "Archivo listo — por favor selecciona un idioma de destino y haz clic en Traducir",
    selectTargetLangFirst: "Por favor selecciona un idioma de destino",
    translationFailed: "Error en la traducción",
    selectTargetLangBeforeUpload: "Por favor selecciona un idioma de destino antes de subir",
    translating: "Traduciendo...",
    translatingDocument: "Traduciendo documento...",

    // Chat
    defaultUsername: "Usuario",
    botName: "LINKO",

    // MenuAI
    presetRequired: "El preset es obligatorio",
    noPresets: "Sin presets",
    promptRequired: "El prompt es obligatorio",
    generateAndDownload: "Generar resumen ejecutivo",
    generatedExecutiveSummarySuccess: "Resumen ejecutivo generado con éxito",
    noChatHistoryFound: "No se encontró historial de chat. Por favor, inicie una conversación primero.",
    noTranslateDataFound: "No se encontró texto para traducir. Por favor, ingrese texto primero.",
    noTranscribeDataFound: "No se encontró transcripción. Por favor, transcriba audio primero.",
    aiResult: "Resultado de IA",
    apply: "Aplicar",

    // Sidebar extra
    defaultOrgName: "ORG / EMPRESA",
    tokenWarning90ClickToUpgrade: "Has alcanzado el 90% de tu límite de tokens. Haz clic aquí para actualizar tu plan",
  },
};

export default translations;
